export const ElementRoutes = {
  Library: "/library",
} as const;
